// extracted by mini-css-extract-plugin
export default {"container":"Xo-z","brandName":"Yo-z","productName":"Zo-z","productNamePdpEnhancements":"_o-z","breakLongProductName":"ap-z"};